type Option = {
  name?: string | null;
  value?: string | number | null;
};

export const displayOption = (
  data: Partial<Option> | Option[] | null,
  otherValue?: string | null,
  defaultValue = '',
): string => {
  if (!data) return defaultValue;

  if (Array.isArray(data)) {
    if (!data.length) return defaultValue;

    return displayMultipleOptions(data, otherValue);
  }
  return displaySingleOption(data, otherValue);
};

const displaySingleOption = (
  { name, value }: Option,
  otherValue?: string | null,
): string => `${name}${value === 'other' ? `: ${otherValue}` : ''}`;

const displayMultipleOptions = (
  data: Option[],
  otherValue?: string | null,
): string =>
  [...data]
    .sort(({ value }) => (value === 'other' ? 1 : -1))
    .map((data) => displaySingleOption(data, otherValue))
    .join(', ');
